import { mapActions, mapGetters } from "vuex";
import * as types from "@/store/types";
import { UserService } from "@/services";

const Level = () =>
  import(
    /* webpackChunkName: "AccountLevel" */ "@/components/AccountPage/Level/index"
  );
const Personal = () =>
  import(
    /* webpackChunkName: "AccountPersonal" */ "@/components/AccountPage/Personal/index"
  );
const Banking = () =>
  import(
    /* webpackChunkName: "AccountBanking" */ "@/components/AccountPage/Banking/index"
  );
const Security = () =>
  import(
    /* webpackChunkName: "AccountSecurity" */ "@/components/AccountPage/Security/index"
  );

export default {
  name: "account-page",
  components: { Personal, Banking, Security, Level },
  props: [],
  data() {
    return {
      tabs: [
        {
          title: this.$t("accountPage.level.title"),
          component: "level",
          route: "/account/level"
        },
        {
          title: this.$t("accountPage.identityInformation.title"),
          component: "personal",
          route: "/account/personal"
        },
        {
          title: this.$t("accountPage.bankInformation.title"),
          component: "banking",
          route: "/account/banking"
        },
        {
          title: this.$t("accountPage.security.title"),
          component: "security",
          route: "/account/security"
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      getSelectedTab: types.account.getters.SELECTED_TAB
    }),
    selectedTab: {
      get() {
        return this.getSelectedTab;
      },
      set(val) {
        this.setTab(val);
        // switch (val) {
        //   case 0:
        //     if (this.$route.query.tab !== this.tabs[0].component) {
        //       this.$router.push({
        //         path: "account/personal",
        //       });
        //     }
        //     break;
        //   case 1:
        //     if (this.$route.query.tab !== this.tabs[1].component) {
        //       this.$router.push({
        //         path: "account/banking",
        //       });
        //     }
        //     break;
        //   case 2:
        //     if (this.$route.query.tab !== this.tabs[2].component) {
        //       this.$router.push({
        //         path: "account/security",
        //       });
        //     }
        //     break;
        // }
      }
    }
  },
  mounted() {
    // this.tabQuery(this.$route.query.tab);
    this.getAuthVerifyInfo();
    this.getUserInfo();
  },
  methods: {
    ...mapActions({
      setTab: types.account.actions.SET_TAB,
      setUserData: types.userInfo.actions.ACTION_USER_INFO,
      setVerifyData: types.userVerifyInfo.actions.SET_USER_VERIFY_INFO
    }),
    getAuthVerifyInfo() {
      UserService.getVerifyInfo().then(response => {
        this.setVerifyData(response.data.data);
      });
    },
    getUserInfo() {
      UserService.getInfo().then(response => {
        this.setUserData(response.data.data);
      });
    }
    // tabQuery(tab) {
    //   if (tab) {
    //     switch (tab) {
    //       case "personal":
    //         if (this.selectedTab !== 0) {
    //           this.selectedTab = 0;
    //         }
    //         break;
    //       case "banking":
    //         if (this.selectedTab !== 1) {
    //           this.selectedTab = 1;
    //         }
    //         break;
    //       case "security":
    //         if (this.selectedTab !== 2) {
    //           this.selectedTab = 2;
    //         }
    //         break;
    //     }
    //   }
    // },
  },
  watch: {
    // $route(route) {
    //   const {
    //     query: { tab },
    //   } = route;
    //   switch (tab) {
    //     case "personal":
    //       if (this.selectedTab !== 0) {
    //         this.selectedTab = 0;
    //       }
    //       break;
    //     case "banking":
    //       if (this.selectedTab !== 1) {
    //         this.selectedTab = 1;
    //       }
    //       break;
    //     case "security":
    //       if (this.selectedTab !== 2) {
    //         this.selectedTab = 2;
    //       }
    //       break;
    //   }
    // },
  }
};
